<template>
  <div
    :title="menuTitle"
    :data-selected="isSelected"
    class="menu-item"
    @click.stop="$emit('menuClick', item)"
    @keydown.enter="$emit('menuClick', item)"
  >
    <div v-if="typeof item.new != 'undefined' && item.new > 0" class="new-content-icon">
      {{ item.new }}
    </div>
    <div class="position-relative">
      <badge-notification v-if="badges > 0" :amount="badges" :border="true" />
      <img v-if="isImage" class="menu-icon" :src="menuIconImageSource" :alt="item.name" />
      <i v-else class="menu-icon" :class="menuIconImageSource" />
    </div>
    <div class="menu-text text-truncate" :class="{ 'widget-text': isWidget }">
      {{ menuTitle }}
    </div>
  </div>
</template>

<script>
import BadgeNotification from '../../../shared/components/BadgeNotification.vue';
import { institutionRole } from '../../../shared/enums/institutionRole';
import { menuUtil } from '../../../shared/utils/menuUtil';
import { useUserProfileStore } from '../../../shared/stores';

export default {
  components: {
    'badge-notification': BadgeNotification,
  },
  props: {
    item: Object,
    badges: { type: Number, default: 0 },
  },
  data: function () {
    return {
      institutionRole,
    };
  },
  computed: {
    userProfileStore() {
      return useUserProfileStore();
    },
    profile() {
      return this.userProfileStore.institutionProfile;
    },
    isSelected() {
      let path = this.item.url;
      if (this.item.widgetId) {
        path = '/widgets/W' + this.item.widgetId + 'V' + this.item.widgetVersion;
      }

      return Boolean(this.$route.path.match(`^${path}`));
    },
    menuTitle() {
      const menuTextKey = menuUtil.getMenuType(this.item.type);
      if (menuTextKey) {
        return this.$getText(menuTextKey);
      }
      return this.item.name;
    },
    isWidget() {
      return this.item.widgetId != null;
    },
    isImage() {
      return menuUtil.getIsIconImage(this.menuIconImageSource);
    },
    menuIconImageSource() {
      if (this.isChild && !this.isWidget) {
        return 'static/icons/' + this.item.icon + '_child.svg';
      }
      if (this.isWidget && !this.item.icon) {
        return 'icon-Aula_widget';
      }
      if (this.isSelected && this.item.iconHover?.length > 0) {
        return this.item.iconHover;
      }
      return menuUtil.getMenuIconClass(this.item);
    },
    isChild() {
      return this.userProfileStore.institutionRoles.includes(this.institutionRole.EARLY_STUDENT);
    },
  },
};
</script>

<style scoped lang="scss">
@use '../../../shared/assets/scss/core/breakpoints' as *;

.menu-item {
  .menu-text {
    text-transform: capitalize;
    &.widget-text {
      text-transform: none;
    }
    .early-student & {
      color: #fff !important;
      text-transform: capitalize;
      font-family: Baloo, serif;
      font-weight: normal;
    }
  }
  ::v-deep .badge-notification {
    .badge span {
      .early-student & {
        top: -6px !important;
        left: -1px !important;
      }
    }
    @include breakpoint-lg-down() {
      .early-student & {
        margin-top: -2px;
        margin-left: 3px;
      }
      .badge span {
        .early-student & {
          left: 0 !important;
        }
      }
    }
  }
}
</style>
